/* =============================================================================
   Furniselan — inner page widgets
   ============================================================================= */
(function () {
  'use strict';

  var FS = window.FS, qs = FS.qs, qsa = FS.qsa, once = FS.once;


  function prefillAndJump(link, text) {
    var target = qs(link.getAttribute('href'));
    if (!target) return false;
    var msg = qs('[data-contact-message]', target);
    if (msg && (!msg.value.trim() || msg.dataset.prefilled === msg.value)) {
      msg.value = text + '\n\n';
      msg.dataset.prefilled = msg.value;
    }
    var name = qs('input[type="text"]', target);
    FS.scrollToTarget(target, { onDone: function () { if (name) name.focus({ preventScroll: true }); } });
    return true;
  }

  function initPrefill(ctx) {
    qsa('[data-prefill]', ctx).forEach(function (link) {
      if (!once(link, 'Prefill')) return;
      link.addEventListener('click', function (e) { if (prefillAndJump(link, link.dataset.prefill)) e.preventDefault(); });
    });
  }

  function initPackages(ctx) {
    qsa('[data-packages]', ctx).forEach(function (root) {
      if (!once(root, 'Packages')) return;
      var tabs = qsa('[data-package-tab]', root), panels = qsa('[data-package]', root);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
          panels.forEach(function (p) { p.hidden = p.dataset.package !== tab.dataset.packageTab; });
        });
      });
      qsa('[data-package-inquire]', root).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          var text = btn.dataset.packageTitle + '\n' + (FS.T.strings.packageItems || 'Items') + ': ' + btn.dataset.packageItems;
          if (prefillAndJump(btn, text)) e.preventDefault();
        });
      });
    });
  }

  function initNews(ctx) {
    qsa('[data-news]', ctx).forEach(function (root) {
      if (!once(root, 'News')) return;
      var more = qs('[data-news-more]', root);
      if (!more) return;
      more.addEventListener('click', function () {
        qsa('[data-news-extra]', root).forEach(function (card) { card.hidden = false; card.classList.add('is-inview'); });
        more.parentNode.hidden = true;
      });
    });
  }


  function initBrokenImages(ctx) {
    qsa('.article-body .rte img, .article-card__media img, .blog-featured__media img', ctx).forEach(function (img) {
      if (!once(img, 'ImgCheck')) return;
      function hide() {
        img.hidden = true;
        var media = img.closest('.article-card__media');
        if (media) media.classList.add('article-card__media--empty');
      }
      if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) hide();
      else img.addEventListener('error', hide, { once: true });
    });
  }

  function initReviews(ctx) {
    qsa('[data-reviews]', ctx).forEach(function (root) {
      if (!once(root, 'Reviews')) return;
      var cards = qsa('[data-review]', root), filters = qsa('[data-review-filter]', root);
      var moreWrap = qs('[data-review-more-wrap]', root), expanded = false, current = 'all';

      function render() {
        cards.forEach(function (c) {
          var match = current === 'all' || c.dataset.category === current;
          c.hidden = !match || (current === 'all' && !expanded && c.hasAttribute('data-review-extra'));
          if (!c.hidden) c.classList.add('is-inview');
        });
        if (moreWrap) moreWrap.hidden = expanded || current !== 'all';
      }

      var more = qs('[data-review-more]', root);
      if (more) more.addEventListener('click', function () { expanded = true; render(); });
      filters.forEach(function (f) {
        f.addEventListener('click', function () {
          current = f.dataset.reviewFilter;
          filters.forEach(function (x) { var on = x === f; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', String(on)); });
          render();
        });
      });
    });
  }


  function initVideoReels(ctx) {
    var videos = qsa('[data-reel] video[data-src]', ctx).filter(function (v) { return once(v, 'Reel'); });
    if (!videos.length) return;

    function load(v) { if (!v.getAttribute('src')) { v.src = v.dataset.src; } }
    function setSound(v, on) {
      var reel = v.closest('[data-reel]'), btn = qs('[data-reel-sound]', reel);
      v.muted = !on;
      reel.classList.toggle('is-sound', on);
      if (btn) { btn.setAttribute('aria-pressed', String(on)); btn.setAttribute('aria-label', on ? btn.dataset.labelOff : btn.dataset.labelOn); }
    }

    videos.forEach(function (v) {
      var btn = qs('[data-reel-sound]', v.closest('[data-reel]'));
      if (!btn) return;
      btn.addEventListener('click', function () {
        var turnOn = v.muted;
        if (turnOn) qsa('[data-reel] video').forEach(function (o) { if (o !== v) setSound(o, false); });
        load(v);
        setSound(v, turnOn);
        if (turnOn) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });

    if (!('IntersectionObserver' in window)) { videos.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          load(v);
          if (!FS.reduceMotion || !v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 });
    videos.forEach(function (v) { io.observe(v); });
  }


 
  function initPinInline(ctx) {
    qsa('[data-pin-inline]', ctx).forEach(function (root) {
      if (!once(root, 'PinInline')) return;
      var form = qs('[data-pin-inline-form]', root), inp = qs('[data-pin-inline-input]', root), res = qs('[data-pin-inline-result]', root);
      if (!form || !inp || !res) return;
      var S = (FS.T && FS.T.strings) || {};
      var decoder = document.createElement('textarea');
      function str(key, fallback) { decoder.innerHTML = S[key] || fallback || ''; return decoder.value; }

      function zones() {
        var modal = qs('[data-pin-modal]');
        try { return JSON.parse((modal && modal.dataset.zones) || '[]'); } catch (e) { return []; }
      }

      function metaZones() {
        var modal = qs('[data-pin-modal]');
        try { return JSON.parse((modal && modal.dataset.metaobjectZones) || '[]'); } catch (e) { return []; }
      }

      function getMetaStatus(pin) {
        if (!pin || pin.length !== 6) return null;
        var mzList = metaZones();
        for (var i = 0; i < mzList.length; i++) {
          var mz = mzList[i];
          if (mz.handle !== 'ready-stock' && mz.handle !== 'made-to-order') {
            if (mz.zips && mz.zips.indexOf(pin) > -1) {
              return { type: 'express', label: mz.label, message: mz.message || 'Estimated Delivery Timeline 1 to 2 Days', image: mz.image };
            }
          }
        }
        for (var k = 0; k < mzList.length; k++) {
          var mz2 = mzList[k];
          if (mz2.handle === 'ready-stock' && mz2.zips && mz2.zips.indexOf(pin) > -1) {
            return { type: 'ready-stock', label: 'Ready Stock', message: mz2.message || 'Estimated Delivery Timeline 8 to 9 Days', image: mz2.image };
          }
        }
        for (var m = 0; m < mzList.length; m++) {
          var mz3 = mzList[m];
          if (mz3.handle === 'made-to-order' && mz3.zips && mz3.zips.indexOf(pin) > -1) {
            return { type: 'made-to-order', label: 'Made to Order', message: mz3.message || 'Estimated Delivery Timeline 20 to 25 Days', image: mz3.image };
          }
        }
        return null;
      }

      function show(cls, title, detail) {
        res.className = 'pin-check__result' + (cls ? ' ' + cls : '');
        res.textContent = '';
        var b = document.createElement('b'); b.textContent = title; res.appendChild(b);
        if (detail) { var s = document.createElement('span'); s.textContent = detail; res.appendChild(s); }
        res.hidden = false;
      }

      try { var saved = localStorage.getItem('fs-pincode'); if (saved) inp.value = saved; } catch (e) { /* ignore */ }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = inp.value.replace(/[^0-9]/g, '');
        if (v.length !== 6) { show('is-error', str('pinInvalid', 'Please enter 6 digits')); inp.focus(); return; }
        
        var prodRes = typeof window.checkProductDelivery === 'function' ? window.checkProductDelivery(v) : null;
        var ms = getMetaStatus(v);
        var hit = null;
        zones().forEach(function (z) { if (!hit && v.indexOf(String(z.prefix)) === 0) hit = z.city; });

        if (prodRes) {
          if (prodRes.available) {
            show('is-express', prodRes.message, str('pinDeliverTo', 'Deliver to [pincode]').replace('[pincode]', v));
          } else {
            show('is-error', prodRes.message, '');
          }
        } else if (ms) {
          if (ms.type === 'express') {
            show('is-express', '⚡ ' + ms.message + ' (' + ms.label + ')', str('pinDeliverTo', 'Deliver to [pincode]').replace('[pincode]', v));
          } else {
            show('', ms.message, str('pinDeliverTo', 'Deliver to [pincode]').replace('[pincode]', v));
          }
        } else if (hit) {
          show('is-express', str('pinExpress').replace('[city]', hit), str('pinExpressDetail').replace('[pincode]', v));
        } else {
          show('is-error', 'Delivery not available at this pincode (Please contact customer support team).', '');
        }

        var isExpress = (prodRes && prodRes.isExpress) || (ms && ms.type === 'express') || !!hit;
        qsa('[data-pin-label]').forEach(function (l) { l.textContent = str('pinDeliverTo', 'Deliver to [pincode]').replace('[pincode]', v) + (isExpress ? ' ⚡' : ''); });
        qsa('#pdpPin, [data-pdp-pin]').forEach(function (el) { el.textContent = v; });
        try { localStorage.setItem('fs-pincode', v); } catch (err) { /* ignore */ }
        window.dispatchEvent(new CustomEvent('pincode:updated', { detail: { pincode: v, city: hit || (ms && ms.label) } }));
      });
    });
  }


  function initHelpSearch(ctx) {
    qsa('[data-help-search]', ctx).forEach(function (form) {
      if (!once(form, 'HelpSearch')) return;
      var root = form.closest('[data-help-hero]') || document;
      var inp = qs('[data-help-search-input]', form), clear = qs('[data-help-clear]', form), status = qs('[data-help-status]', root);
      var timer = null;

      function run(jump) {
        var raw = inp.value.trim(), terms = raw.toLowerCase().split(/\s+/).filter(Boolean);
        var first = null, count = 0;
        if (clear) clear.hidden = !raw;
        qsa('[data-faq-section]').forEach(function (group) {
          var shown = 0;
          qsa('.faq-list details', group).forEach(function (d) {
            var text = d.textContent.toLowerCase();
            var hit = terms.every(function (t) { return text.indexOf(t) !== -1; });
            d.hidden = !hit;
            d.open = terms.length ? hit : d.hasAttribute('data-open-default');
            if (hit) { shown++; if (terms.length && !first) first = d; }
          });
          group.hidden = !shown;
          if (terms.length) count += shown;
        });
        document.dispatchEvent(new CustomEvent('fs:faq-filter'));
        if (!status) return;
        if (!terms.length) { status.hidden = true; return; }
        status.textContent = (count ? status.dataset.found : status.dataset.none).replace('[count]', count).replace('[query]', raw);
        if (!count && status.dataset.contactUrl && status.dataset.contactLabel) {
          var a = document.createElement('a');
          a.href = status.dataset.contactUrl; a.textContent = status.dataset.contactLabel;
          status.appendChild(document.createTextNode(' ')); status.appendChild(a);
        }
        status.hidden = false;
        if (jump && first) FS.scrollToTarget(first.closest('[data-faq-section]'));
      }

      inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { run(false); }, 150); });
      form.addEventListener('submit', function (e) { e.preventDefault(); run(true); });
      if (clear) clear.addEventListener('click', function () { inp.value = ''; run(false); inp.focus(); });
      qsa('[data-help-query]', root).forEach(function (chip) {
        chip.addEventListener('click', function () { inp.value = chip.dataset.helpQuery; run(true); });
      });
    });
  }


  function initFaqNav(ctx) {
    qsa('[data-faq-nav]', ctx).forEach(function (nav) {
      if (!once(nav, 'FaqNav')) return;
      var links = qsa('a[href^="#"]', nav);
      var groups = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
      var current = -1, ticking = false;

      function update() {
        ticking = false;
        var line = window.innerHeight * 0.33, idx = -1;
        groups.forEach(function (g, i) { if (g && !g.hidden && g.getBoundingClientRect().top <= line) idx = i; });
        if (idx < 0) idx = groups.findIndex(function (g) { return g && !g.hidden; });
        if (idx === current) return;
        current = idx;
        links.forEach(function (a, i) {
          var on = i === idx;
          a.classList.toggle('is-active', on);
          if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        });
        var active = links[idx];
        if (active && nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: active.offsetLeft - 20, behavior: FS.reduceMotion ? 'auto' : 'smooth' });
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      document.addEventListener('fs:faq-filter', function () {
        links.forEach(function (a, i) { a.hidden = !!(groups[i] && groups[i].hidden); });
        current = -1; update();
      });
      update();
    });
  }

  /* Help page knowledge base (sections/help-articles.liquid): topic tabs and the Help hub hero
     search filter a card grid; a card opens its answer in a side drawer (FS.Overlay) with
     previous / next. The drawer keeps #help-<id> in the URL so an answer can be linked. */
  function initHelpArticles(ctx) {
    qsa('[data-help-articles]', ctx).forEach(function (root) {
      if (!once(root, 'HelpArticles')) return;
      var cards = qsa('[data-help-card]', root), tabs = qsa('[data-help-tab]', root);
      var tabRow = qs('[data-help-tabs]', root), grid = qs('[data-help-grid]', root);
      var status = qs('[data-help-kb-status]', root), empty = qs('[data-help-empty]', root);
      var emptyText = empty ? qs('[data-help-empty-text]', empty) : null;
      var texts = cards.map(function (c) { return c.textContent.toLowerCase(); });
      var topic = 'all', query = '';

      function shownCards() { return cards.filter(function (c) { return !c.hidden; }); }

      function render() {
        var terms = query.toLowerCase().split(/\s+/).filter(Boolean), shown = [];
        cards.forEach(function (c, i) {
          var match = (topic === 'all' || c.dataset.topic === topic) && terms.every(function (t) { return texts[i].indexOf(t) !== -1; });
          c.hidden = !match;
          c.classList.remove('is-entering');
          if (match) shown.push(c);
        });
        if (grid) void grid.offsetWidth; // restart the entrance animation
        shown.forEach(function (c, i) { c.style.animationDelay = Math.min(i, 8) * 40 + 'ms'; c.classList.add('is-entering'); });
        if (empty) {
          empty.hidden = shown.length > 0;
          if (emptyText) emptyText.textContent = (empty.dataset.none || '').replace('[query]', query);
        }
        if (status) {
          status.hidden = !terms.length || !shown.length;
          if (!status.hidden) status.textContent = (status.dataset.found || '').replace('[count]', shown.length).replace('[query]', query);
        }
      }

      function setTopic(key) {
        topic = key;
        tabs.forEach(function (t) {
          var on = t.dataset.helpTab === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', String(on));
          if (on && tabRow && tabRow.scrollWidth > tabRow.clientWidth) tabRow.scrollTo({ left: t.offsetLeft - 15, behavior: FS.reduceMotion ? 'auto' : 'smooth' });
        });
        render();
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { setTopic(t.dataset.helpTab); }); });

      // Search box + popular links live in the Help hub hero (a separate section on the page).
      var input = qs('[data-help-hub-input]'), form = qs('[data-help-hub-search]'), timer = null;
      function search(q, jump) {
        query = (q || '').trim();
        setTopic(query ? 'all' : topic);
        if (jump) FS.scrollToTarget(root);
      }
      if (input && once(input, 'HelpHub')) {
        input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { search(input.value, false); }, 150); });
        if (form) form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); search(input.value, true); });
        qsa('[data-help-hub-query]').forEach(function (b) {
          b.addEventListener('click', function () { input.value = b.dataset.helpHubQuery; search(input.value, true); });
        });
      }

      var drawer = qs('[data-help-drawer]', root.parentNode);
      if (!drawer) return;
      var dTopic = qs('[data-help-drawer-topic]', drawer), dTitle = qs('[data-help-drawer-title]', drawer);
      var dAnswer = qs('[data-help-drawer-answer]', drawer), dBody = qs('[data-help-drawer-body]', drawer);
      var dCount = qs('[data-help-drawer-count]', drawer), prev = qs('[data-help-prev]', drawer), next = qs('[data-help-next]', drawer);
      var current = -1, isOpen = false, trigger = null;

      function fill(card) {
        var list = shownCards();
        current = list.indexOf(card);
        dTopic.textContent = card.dataset.topicTitle || '';
        dTitle.textContent = qs('[data-help-open]', card).textContent;
        dAnswer.innerHTML = qs('[data-help-answer]', card).innerHTML;
        if (dCount) dCount.textContent = (current + 1) + ' / ' + list.length;
        if (prev) prev.disabled = current <= 0;
        if (next) next.disabled = current < 0 || current >= list.length - 1;
        if (dBody) { dBody.scrollTop = 0; dBody.classList.remove('is-swapping'); void dBody.offsetWidth; dBody.classList.add('is-swapping'); }
        try { history.replaceState(null, '', '#' + card.id); } catch (e) { /* ignore */ }
      }
      function open(card) {
        if (!card) return;
        if (card.hidden) { query = ''; setTopic('all'); }
        trigger = qs('[data-help-open]', card);
        fill(card);
        isOpen = true;
        FS.Overlay.show(drawer);
      }
      // Runs after the drawer was closed by any route: its button, Esc or the scrim.
      function closed() {
        if (!isOpen || drawer.classList.contains('is-open')) return;
        isOpen = false;
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* ignore */ }
        if (trigger) trigger.focus({ preventScroll: true });
      }
      function step(dir) { var card = shownCards()[current + dir]; if (card) fill(card); }

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-help-open]');
        if (btn) { e.preventDefault(); open(btn.closest('[data-help-card]')); }
      });
      qsa('[data-help-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { FS.Overlay.hide(drawer); closed(); }); });
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      drawer.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') step(-1); else if (e.key === 'ArrowRight') step(1); });
      document.addEventListener('fs:escape', closed);
      var scrim = qs('[data-scrim]');
      if (scrim) scrim.addEventListener('click', function () { setTimeout(closed, 0); });

      if (location.hash) {
        var id = location.hash.slice(1);
        
        try { id = decodeURIComponent(id); } catch (e) { /* keep raw */ }
        open(cards.filter(function (c) { return c.id === id; })[0]);
      }
    });
  }

  // Theme editor: selecting an article that the current tab hides switches back to "All".
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('[data-help-card]');
    if (!card || !card.hidden) return;
    var all = qs('[data-help-tab="all"]', card.closest('[data-help-articles]'));
    if (all) all.click();
  });

  function initInnerPages(ctx) { initPrefill(ctx); initPackages(ctx); initNews(ctx); initBrokenImages(ctx); initReviews(ctx); initVideoReels(ctx); initPinInline(ctx); initHelpSearch(ctx); initFaqNav(ctx); initHelpArticles(ctx); }

  window.FS.initInnerPages = initInnerPages;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initInnerPages(document); });
  else initInnerPages(document);
  document.addEventListener('shopify:section:load', function (e) { initInnerPages(e.target); });
})();
